import React, {FC} from "react";
import {Zone} from "../../../../../../domain/patrol/Zone";

type Props = {
    item: Zone;
};

export const ZoneRowName: FC<Props> = ({item}) => {
    const {label} = item;
    return (
        <div className={"m-0 p-0 flex flex-row flex-wrap gap-2"}>
            <span className={"text-neutral-400 font-semibold"}>NOMBRE</span>
            <span>{label}</span>
        </div>
    );
};
